import "./ LicensePlate.scss";

const FA_DIGITS = "۰۱۲۳۴۵۶۷۸۹";
const AR_DIGITS = "٠١٢٣٤٥٦٧٨٩";

// Stored data may hold Persian, Arabic, or English digits — normalize the
// display consistently to Persian digits. Display-only: backend values untouched.
const toPersianDigits = (value) =>
  String(value ?? "")
    .replace(/[0-9]/g, (d) => FA_DIGITS[Number(d)])
    .replace(/[٠-٩]/g, (d) => FA_DIGITS[AR_DIGITS.indexOf(d)])
    .replace(/\s+/g, "");

// Stored plate semantics (see parsePlateString in AddCars + LicensePlateInput
// format "part1 letter part2 | part3"):
//   Main1 (plate1) = first 2 digits, Main2 (plate2) = middle 3 digits,
//   Main3 (plate3) = Persian letter, End (plateEnd) = 2-digit province code.
// Correct Iranian visual order (explicit LTR): 2 digits, letter, 3 digits, end.
function LicensePlate({ Main1, Main2, Main3, End, compact = false }) {
  const firstDigits = toPersianDigits(Main1);
  const middleDigits = toPersianDigits(Main2);
  const letter = String(Main3 ?? "").trim();
  const endDigits = toPersianDigits(End);

  return (
    <div className={`license-plate ${compact ? "compact" : ""}`} dir="ltr" data-testid="license-plate">
      <div className="license-plate__section license-plate__ir">
        <span>IR</span>
      </div>
      <div className="license-plate__section license-plate__main" data-testid="plate-main">
        <span className="license-plate__part license-plate__part--numbers" data-testid="plate-first">{firstDigits}</span>
        <span className="license-plate__part license-plate__part--letter" data-testid="plate-letter">{letter}</span>
        <span className="license-plate__part license-plate__part--numbers" data-testid="plate-middle">{middleDigits}</span>
      </div>
      <div className="license-plate__section license-plate__end" data-testid="plate-end">
        <span>{endDigits}</span>
      </div>
    </div>
  );
}

export default LicensePlate;
